export default __webpack_public_path__ + "static/media/avatar.c9c492c4.png";